export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_eventId') || '事件ID',
    field: 'eventId',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 50,
        'show-word-limit': true,
        clearable: true,
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_eventName') || '事件名称',
    field: 'eventName',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 50,
        'show-word-limit': true,
        clearable: true,
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_task_execution_cycle') || '任务执行周期',
    field: 'taskCron',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 50,
        'show-word-limit': true,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_maxRetryCount') || '最大重试次数',
    field: 'maxRetryCount',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 1000000000,
        step: 1,
        'controls-position': 'right',
      },
    },
  },
  {
    title: '是否必须',
    field: 'required',
    align: 'center',
    minWidth: 100,
    editRender: { enabled: true },
    slots: { default: 'requiredShow', edit: 'required' },
  },
  {
    title: that.$l('table_label_taskBatchCount') || '一次任务处理数据量',
    field: 'taskBatchCount',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 1000000000,
        step: 1,
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },

]
